import { render, staticRenderFns } from "./AiOcrFileUpload.vue?vue&type=template&id=26f1b1d5&scoped=true&"
import script from "./AiOcrFileUpload.vue?vue&type=script&lang=js&"
export * from "./AiOcrFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./AiOcrFileUpload.vue?vue&type=style&index=0&id=26f1b1d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f1b1d5",
  null
  
)

export default component.exports